export const PAYEEZY_PROVIDER_ID = 'PYEZ'
export const UCOM_PROVIDER_ID = 'UCOM'
